import axios from "axios";
import _ from "lodash";
// import {DateTime} from 'luxon';

// import _ from 'lodash';
const axios2  = axios.create({
   timeout: 1000*60*5, //5 mins
});



// let clean_form = {
//    answers: {}, //object indexed by the index position in this.questions. e.g. answers[0] is the answer to this.questions[0]
//    sales_people: [{user_id:'', name: '', email:''}],
//    info_cust:{name_first:'', name_last:'', address:'', city:'', state:'', zip:'', phone:'', email:''},
//    info_lead: {
//       wanted_vehicle:'',
//       lead_source:'',
//       lead_arrived_date: null,
//       lead_arrived_time: null,
//       email_response_date: null,
//       email_response_time: null,
//       phone_response_date: null,
//       phone_response_time: null,
//       no_email_received: false,
//       no_call_received: false
//    },
//    comments_internal:'',
//    comments_external:'',
//    date_grading_started: null,
//
// };




export default {


   methods:{

      func_list(fn_name){
         if (fn_name === 'SUM'){
            return function(){
               let ans = 0;
               for (let i=0; i< arguments.length; i++){
                  ans += Number(arguments[i]);
               }
               return ans;
            }
         }

         else if(fn_name === 'DIFFERENCE'){
            return function(a, b){
               return Number(a) - Number(b);
            }

         }

         else if(fn_name === 'RATIO'){
            return function(a, b){
               return Number(a) / Number(b);
            }

         }
      },

      formatDate (date) {
         if (!date) return null;

         const [year, month, day] = date.split('-');
         return `${month}/${day}/${year}`;
      },
      parseDate (date) {
         if (!date) return null;

         const [month, day, year] = date.split('/');
         return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
      },

      async on_select_dealership(){

         // this.selected_dealer_id = this.form.dealership.id;

         let ix = this.findWithAttr(this.dealerships, '_id', this.selected_dealer_id);
         this.selectedDealership = this.dealerships[ix];

         await this.get_users_local();


         this.showpass = false;
      },

      async get_dealers_local(){
         try {
            this.dealerships = await this.get_dealers({is_active: true, include_crm_info:true});

            for (let i=0; i<this.dealerships.length; i++){
               let d = this.dealerships[i];
               if (d.org_id){
                  this.dealerships[i].txt = d.org_id.name +' / '+d.name;
               }
               else{
                  this.dealerships[i].txt ='No Group/'+d.name;
               }
            }//for i

            this.dealerships = this.dealerships.sort((a, b) => (a.txt > b.txt) ? 1 : -1)

         }
         catch(err){
            console.log(err);
            // ans = err.response.data;
         }
      },

      /**
       * does the following:
       *  1. gets users for selected org
       *  2. splits users into list of sale people and managers
       */
      async get_users_local(){

         //todo: move this logic to the back end.

         let ix = this.findWithAttr(this.dealerships, '_id', this.selected_dealer_id);
         let dealer = this.dealerships[ix];
         let org_id = dealer.org_id._id;

         console.log('debug', dealer)

         let grade_types = dealer.gradable_user_types;
         if (grade_types == null || (Array.isArray(grade_types) && grade_types.length === 0)){
            grade_types = ['SalesPerson'];
         }

         try {
            if (this.selected_dealer_id){
               // let data = await this.get_users({org_id, acct_type:'CLIENT', });
               let data = await this.get_users({dealer_id: this.selected_dealer_id, acct_type:'CLIENT', is_active: true});
               let users_admins = await this.get_users({org_id: org_id, acct_type:'CLIENT', user_role: 'Admin', is_active: true});
               console.log('users', data);
               data = data.concat(users_admins);

               this.salesPeople = [];
               this.managers = [];
               for (let i=0; i<data.length; i++){
                  if (['Admin', 'Executive', 'Manager'].includes(data[i].app_metadata.role)){
                     this.managers.push({
                        name: data[i].name,
                        email: data[i].email,
                        include: data[i].app_metadata.include_on_grades,
                        role: data[i].app_metadata.role,
                        title: data[i].app_metadata.title,
                        user_id: data[i].user_id,
                        app_metadata: data[i].app_metadata,

                     })
                  }

                  let tmp = data[i].app_metadata.dealership_ids.map(x => x._id); //list of dealership ids's
                  // console.log(i, tmp);
                  if (grade_types.includes(data[i].app_metadata.role) && tmp.includes(this.selected_dealer_id)){
                     this.salesPeople.push(data[i])
                  }
               }

               this.salesPeople.sort((a, b) => (a.name > b.name) ? 1 : -1);
            }

         }
         catch(err){
            console.log(err);
            // ans = err.response.data;
         }
      },





      //**************************************************************************
      async get_users_curriculum(curriculum_id){

         console.log({curriculum_id})

         if (curriculum_id == null) {
            //get salesperson level
            let ix = this.findWithAttr(this.salesPeople, 'user_id', this.selectedSalesPerson);
            let sp_level = this.salesPeople[ix].app_metadata.curriculum_level;

            console.log({sp_level})
            if (![1, 2, 3, 4, '1', '2', '3', '4'].includes(sp_level)){
               this.curriculum = null;
               return;
            }

            //get dealership
            ix = this.findWithAttr(this.dealerships, '_id', this.selected_dealer_id);
            let curricula_dealer = this.dealerships[ix].curricula;

            //get org
            // let org = await this.get_org(this.dealerships[ix].org_id._id);
            let org = await this.get_organizations({org_id: this.dealerships[ix].org_id._id});
            let curricula_org = org[0].curricula; //assumes we're getting a single org back

            //get dealer's or org's curriculum of each level as appropriate
            let curricula = {
               '1': curricula_dealer.level_1 ? curricula_dealer.level_1: curricula_org.level_1,
               '2': curricula_dealer.level_2 ? curricula_dealer.level_2: curricula_org.level_2,
               '3': curricula_dealer.level_3 ? curricula_dealer.level_3: curricula_org.level_3,
               '4': curricula_dealer.level_4 ? curricula_dealer.level_4: curricula_org.level_4,
            };


            curriculum_id = curricula[sp_level];
            console.log('curricula', curricula)
            console.log('curricula_org', curricula_org)
            console.log('curricula_org', curricula_org)
            console.log('sp_level', sp_level)
            console.log('curriculum_id', curriculum_id)
         }


         //get curriculum
         // this.curriculum = await this.get_curriculum_db(curriculum_id);
         this.curriculum = await this.get_curricula({_id: curriculum_id, get_q_data:true});
         this.curriculum = this.curriculum[0];

         //attach function for linked questions
         // let questions = this.curriculum.questions;



         // for (let i=0; i<questions.length; i++){
         //    let lq = questions[i].q_id.linked_questions;
         //
         //    if (lq !== null){
         //       let ixs = [];
         //       let vals = [];
         //       //get function
         //       questions[i].compute = this.func_list(lq.function);
         //
         //       //get question id's for input questions
         //       for (let j=0; j<lq.inputs.length; j++){
         //          let ix = this.findWithAttr(this.questions, 'q_id._id', lq.inputs[j]);
         //          ixs.push(ix);
         //          vals.push(this.form.answers[ix])
         //       }
         //
         //       //define the event listener
         //       let listener = function () {
         //          return this.func_list(lq.function)(...vals);
         //
         //       }
         //
         //
         //
         //    }
         // }



         this.initialize_answers();

         // for (let i=0; i<questions.length; i++){
         //
         //    let answers = questions[i].q_id.answers;
         //    for (let j=0; j<answers.length; j++){
         //       //add ix to all answers for each question (needed if want display as dropdown)
         //       answers[j].ix = j;
         //
         //
         //       // converting json answers
         //       // assumes that answer is a json string of the form '{"range": [a, b], "txt": "..."}'
         //       let json = questions[i].q_id.answers[j].ans;
         //       try{
         //          if (json.includes('{')){
         //             json = JSON.parse(json);
         //             answers[j].json = json;
         //             answers[j].ans = json.txt;
         //          }
         //          else{
         //             answers[j].json = null;
         //          }
         //
         //       }
         //       catch(e){
         //          answers[j].json = null;
         //          console.error(e);
         //
         //       }
         //
         //
         //    }
         // }

      },


      initialize_answers(){
         //process raw answer data stored in db.  in particulular, it checks for a json string and converts it to an
         // object
         let questions = this.curriculum.questions;
         for (let i=0; i<questions.length; i++){

            let answers = questions[i].q_id.answers; //this is just "pointer" data in this.curriculum for convenience
            for (let j=0; j<answers.length; j++){
               //add ix to all answers for each question (needed if want display as dropdown)
               answers[j].ix = j;


               // converting json answers
               // assumes that answer is a json string of the form '{"range": [a, b], "txt": "..."}'
               let json = questions[i].q_id.answers[j].ans;
               try{
                  if (json.includes('{')){
                     json = JSON.parse(json);
                     answers[j].json = json;
                     answers[j].ans = json.txt;
                  }
                  else{
                     answers[j].json = null;
                  }

               }
               catch(e){
                  answers[j].json = null;
                  console.error(e);

               }


            }
         }


      },



      async get_coachup_curriculum(curriculum_id){

         console.log({curriculum_id})

         if (curriculum_id == null) {
            throw Error('Curriculum_id must be specified')
         }


         //get curriculum
         // this.curriculum = await this.get_curriculum_db(curriculum_id);
         this.curriculum = await this.get_curricula({_id: curriculum_id, get_q_data:true});
         this.curriculum = this.curriculum[0];

         this.initialize_answers()


      }, //get_coachup_curriculum()

      //**************************************************************************



      /**
       * helper fn which formats answer text depending on if the question is linked or not
       * @param q_id - the curriculum.questions[ix].q_id object
       * @param j    - int, the index for ans text to return
       * @returns {((query: string, callback: (answer: string) => void) => void) | *[] | string}
       */
      fmt_q_text(q_id, j){

         let ans = q_id.answers[j].ans;
         if (q_id.linked_questions != null){
            try{
               let tmp = JSON.parse(ans);
               ans = tmp.txt;
            }
            catch(e){
               console.error(e)
            }
         }
         return ans;


      },


      disable_ans(q) {
         let ans = false;

         if (q.linked_questions === null)
            ans = false;
         else if (q.linked_questions.link_type === 'FunctionOf')
            ans = false;


         return ans;
      },






//****************************************************************************************************************
      /**
       *
       * @param ix_this_q : index of the question that just changed
       */

      // grade_form(ix_this_q){
      //    try{
      //       this.grade_form0(ix_this_q);
      //    }
      //    catch(e){
      //       this.edit_error_msg = `Cannot compute grade.  This is most likely due to the curriculum and/or question(s) being changed since this lead was originally graded.`;
      //    }
      // },
      // grade_form0(ix_this_q){
      //    if (!this.curriculum){
      //       return;
      //    }
      //
      //    let questions = this.curriculum.questions;
      //    this.grade_score = 0;
      //    let max_score = 0;
      //
      //    // compute max score including duplicates
      //    for (let i=0; i<questions.length; i++){
      //       max_score +=  questions[i].weight;
      //    }
      //
      //
      //    //compute answers for linked questions****************************
      //    for (let i=0; i<questions.length; i++){
      //       let lq = questions[i].q_id.linked_questions;
      //       // console.log(lq)
      //
      //       if (lq !== null && i !== ix_this_q){
      //          let vals = [];
      //
      //          //get question id's for input questions
      //          for (let j=0; j<lq.inputs.length; j++){
      //             let ix = this.findWithAttr(questions, 'q_id._id', lq.inputs[j].q_id);
      //             let ans_ix = this.form.answers[ix];
      //
      //             console.log('ix', ix, 'ans_ix', ans_ix);
      //             if (ix !== -1 && ans_ix !== undefined){
      //                let val = this.curriculum.questions[ix].q_id.answers[ans_ix].ans;
      //                // val = val.split(' ')[0];
      //                vals.push(val);
      //             }else{
      //                vals.push(null);
      //             }
      //          }
      //
      //
      //          console.log('q', i+1, 'input vals', vals);
      //
      //          //********get computed answer***********************************
      //          if (lq.link_type === 'FunctionOf'){
      //
      //             vals = vals.map(x => typeof x === 'string' ? x.split(' ')[0] : NaN); //needed in case the ans val is "10 or more"
      //             let ans = this.func_list(lq.function)(...vals);
      //             console.log('computed ans', ans)
      //
      //
      //             //get the index of the answer for this question
      //             // assumes answers[j].json is not null and has form {"range": [a, b], "txt": "..."}
      //             for (let j=0; j<questions[i].q_id.answers.length; j++){
      //                try{
      //                   let range = questions[i].q_id.answers[j].json.range;
      //                   if (ans > range[0] && ans <= range[1]){
      //                      this.form.answers[i.toString()] = j; // note, answers is an object, not an array
      //                      break;
      //                   }
      //                }
      //                catch(e){
      //                   console.error(e);
      //                }
      //             }
      //          }// if FunctionOf
      //
      //          //********check if we need to exclude this question********
      //          else if (lq.link_type === 'ExcludeOn'){
      //
      //             let exclude_val = "Doesn't Apply";
      //
      //             //check if at least one input's answer is set
      //             if ( vals.some(x => x !== exclude_val && typeof x === 'string')){
      //                //then set this question's value to "Not Applicable"
      //
      //                //get index of "Not Applicable" answer for this question
      //                let ans_ix = this.findWithAttr(questions[i].q_id.answers, 'ans', exclude_val);
      //
      //                if (ans_ix > -1 ){
      //                   this.form.answers[i] = ans_ix; //questions[i].q_id.answers[ans_ix].;
      //                   console.log(`setting answer =${i}, to value=${ans_ix}`)
      //                }
      //                else{
      //                   console.log(`Coudn't get index of "${exclude_val}" answer`)
      //                }
      //             }
      //          }// if ExcludeOn
      //
      //          //********check if dependsOn********
      //          else if (lq.link_type === 'DependsOn'){
      //
      //             for (let j=0; j<vals.length; j++){
      //
      //                console.log('if_these', lq.inputs[j].if_these)
      //                if (lq.inputs[j].if_these.includes(vals[j])){
      //
      //                   let ans_ix = this.findWithAttr(questions[i].q_id.answers, 'ans', lq.inputs[j].ans_to_set);
      //                   if (ans_ix > -1 ){
      //                      this.form.answers[i] = ans_ix; //questions[i].q_id.answers[ans_ix].;
      //                      console.log(`setting answer =${i}, to value=${ans_ix}`)
      //                   }
      //                   else{
      //                      console.log(`Coudn't get index of "${lq.inputs[j].ans_to_set}" answer`)
      //                   }
      //                }
      //             }
      //
      //          }// if DependsOn
      //
      //       }//if this is a linked question
      //
      //    }//for questions
      //
      //    // end of compute answers for linked questions****************************
      //
      //
      //    // compute score based on current answers
      //    let i=0;
      //    for (i=0; i<questions.length; i++){
      //
      //
      //
      //       let ans_score = 0;
      //       let ans_ix = this.form.answers[i];
      //
      //       //check if the question has been answered and grabs score of the answer if it has
      //       if (ans_ix !== undefined){
      //
      //          // console.log({i, ans_ix})
      //
      //          // check if the answer is "Not applicable"
      //          let tmp = questions[i].q_id.answers[ans_ix].score;
      //          if (parseInt(tmp) === -1){
      //             max_score -= questions[i].weight;
      //             ans_score = 0
      //          }
      //          else{
      //             ans_score = questions[i].q_id.answers[ans_ix].score
      //          }
      //       }// if ans_id is defined
      //
      //       this.grade_score += ans_score*questions[i].weight;
      //       // console.log(ans_ix, ans_score, questions[i])
      //    }//for i
      //
      //    this.grade_score = this.grade_score/max_score*100;
      //
      //    // this.grade_score = this.round(this.grade_score, 2);
      //
      //    //get letter grade
      //    this.grade_letter = null;
      //    i=0;
      //    while (this.grade_letter === null){
      //       let low = this.curriculum.grading_scale[i].score_low;
      //       let high = this.curriculum.grading_scale[i].score_high;
      //
      //       //deal with score being above 100 or below 0
      //       if (i===0) high += 100;
      //       if (i===this.curriculum.grading_scale.length-1) low -= 100;
      //
      //       if (low < this.grade_score && this.grade_score <= high){
      //          this.grade_letter = this.curriculum.grading_scale[i].grade;
      //       }
      //       i++;
      //    }
      //
      //
      //
      //
      //    console.log('max_score', max_score)
      //
      // },


      //****************************************************************************************************************



      //**************************************************************************
      selectFile(i){

         if (this.$refs.fileInputs[i].files[0]){

            this.files[i].file = this.$refs.fileInputs[i].files[0];
            this.files[i].name = this.files[i].file.name;
         }

      },


      //**************************************************************************
      async upload_files0(){
         try {
            this.submit_upload_files = true;
            //create form data object to pass to upload endpoint
            let formData = new FormData();

            for (let i=0; i<this.files.length; i++){
               if (this.files[i].file !== null){
                  formData.append('file', this.files[i].file)
               }
            }


            //get dealerships's name
            // let ix = this.findWithAttr(this.dealerships, '_id', this.selected_dealer_id);
            // let prefix = this.dealerships[ix].org_id.name + '/' + this.dealerships[ix].name;
            let prefix = 'dealer_id:'+this.selected_dealer_id;

            formData.append('file_prefix', prefix);

            // note: for some fucking reason, you cannot access formData objects directly.
            // i.e. logging formData will just show an empty object
            for (var data of formData) {
               console.log(data);
            }

            let file_ids = this.existing_files;
            if (file_ids == null){
               file_ids = [];
            }

            if (!this.isEditMode){
               file_ids = [];
            }



            if (formData.getAll('file').length > 0){
               let token = await this.$auth.getAxiosHeader();
               token.headers['content-type'] = 'multipart/form-data';
               let url = this.$baseUrlApi + '/uploadDocument';
               let res = await axios2.post(url, formData, token);



               //todo: really needs to move record update to the backend.  Issue is that we've combined the screencast url and files.  These really should have been separate

               // console.log('res', res)
               //add uploaded file info to graded lead.  Note uploadDocument returns a list of objects with info for each file that was uploaded
               for (let i=0; i<res.data.length; i++){
                  file_ids.push({
                     file_id: res.data[i].file_id,
                     url: res.data[i].url,
                     type: res.data[i].file.headers['content-type'],
                     filename: this.files[i].name, // added 2/23/2021
                  })
               }
            }//if there's form data


            this.saved_data.file_ids = file_ids;
            let urls = [];

            if (this.screencast_url !== ''){
               urls = [this.screencast_url]
            }

            let post_data = {
               _id: this.saved_data.form_id,
               additional_data: {
                  files: file_ids,
                  info_urls: urls
               }
            };

            //TODO: if user goes back and uploads a different file, the old file stays on server (with no linked lead)
            let token2 = await this.$auth.getAxiosHeader();
            let url2 = this.$baseUrlApi + '/saveGradedLead';
            await axios.post(url2, post_data, token2);


            this.files = [{file: null, name:null}];
            if (!this.isEditMode){
               this.stepper_step = 4;
            }

         }
         catch(err){
            this.show_error_details(err, 'upload_files()');
            this.form_error_3 = "There was an issues uploading files to server."

         }
         this.submit_upload_files = false;
      },



      async upload_files(){
         try {
            this.submit_upload_files = true;
            //create form data object to pass to upload endpoint
            let formData = new FormData();

            for (let i=0; i<this.files.length; i++){
               if (this.files[i].file !== null){
                  formData.append('file', this.files[i].file)
               }
            }


            //get dealerships's name
            // let ix = this.findWithAttr(this.dealerships, '_id', this.selected_dealer_id);
            // let prefix = this.dealerships[ix].org_id.name + '/' + this.dealerships[ix].name;
            let prefix = 'dealer_id:'+this.selected_dealer_id;

            formData.append('file_prefix', prefix);

            // note: for some fucking reason, you cannot access formData objects directly.
            // i.e. logging formData will just show an empty object
            for (var data of formData) {
               console.log(data);
            }

            let file_ids = this.existing_files;
            if (file_ids == null){
               file_ids = [];
            }

            if (!this.isEditMode){
               file_ids = [];
            }


            if (formData.getAll('file').length > 0){
               let token = await this.$auth.getAxiosHeader();
               token.headers['content-type'] = 'multipart/form-data';
               let url = this.$baseUrlApi + '/uploadDocument';
               let res = await axios2.post(url, formData, token);



               //todo: really needs to move record update to the backend.  Issue is that we've combined the screencast url and files.  These really should have been separate

               // console.log('res', res)
               //add uploaded file info to graded lead.  Note uploadDocument returns a list of objects with info for each file that was uploaded
               for (let i=0; i<res.data.length; i++){
                  file_ids.push({
                     file_id: res.data[i].file_id,
                     url: res.data[i].url,
                     type: res.data[i].file.headers['content-type'],
                     filename: this.files[i].name, // added 2/23/2021
                  })
               }
            }//if there's form data


            this.saved_data.file_ids = file_ids;
            let urls = [];

            if (this.screencast_url !== ''){
               urls = [this.screencast_url]
            }

            let post_data = {
               _id: this.saved_data.form_id,
               additional_data: {
                  files: file_ids,
                  info_urls: urls
               }
            };

            //TODO: if user goes back and uploads a different file, the old file stays on server (with no linked lead)
            let token2 = await this.$auth.getAxiosHeader();
            let url2 = this.$baseUrlApi + '/saveGradedLead';
            await axios.post(url2, post_data, token2);


            this.files = [{file: null, name:null}];
            if (!this.isEditMode){
               this.stepper_step = 4;
            }

         }
         catch(err){
            this.show_error_details(err, 'upload_files()');
            this.form_error_3 = "There was an issues uploading files to server."

         }
         this.submit_upload_files = false;
      },



      //*******************functions for edit mode ***********************************************************

      async skip_to_docs(){

         if (!this.$refs.form_2.validate()){
            this.form_error_2 = 'Please check highlighted fields.';
            return;
         }

         //get files for this grade



         this.stepper_step=3;
      },



      async download_file(file_id, save_name){

         let token = await this.$auth.getAxiosHeader();
         let url = this.$baseUrlApi + '/getFile';
         // let ext = filename.split('.');
         // ext = ext[ext.length];
         // let type = 'application/'+ext;


         if (save_name == null){
            save_name = file_id.split('/');
            save_name = save_name[save_name.length-1];
         }


         axios({
            url: url,
            method: 'post',
            data: {file_key: file_id},
            responseType: 'blob', // important
            headers: token['headers'],
         }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', save_name );
            document.body.appendChild(link);
            link.click();
         });

      },
   },//methods
}
